module.exports = __webpack_public_path__ + "static/media/dine-in.f8ab58e7.svg";